import './Footer.scss';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import conferenceLogo from '../../../assets/icons/conference-league.png';
import eredivisieLogo from '../../../assets/icons/eredivisie.png';
import eredivisieLogoDark from '../../../assets/icons/eredivisie-dark.png';
import eredivisieVrouwenLogo from '../../../assets/icons/azerion-eredivisie-vrouwen.png';
import europaLeagueLogo from '../../../assets/icons/europa-league.png';
import facebookLogo from '../../../assets/icons/facebook-icon.png';
import instagramLogo from '../../../assets/icons/instagram-icon.png';
import kkdLogo from '../../../assets/icons/keuken-kampioen-divisie.png';
import knvbLogo from '../../../assets/icons/knvb-beker.png';
import logo from '../../../assets/images/logo-espn.svg';
import logoRed from '../../../assets/images/logo-espn-red.svg';
import podcastIcon from '../../../assets/icons/connect.png';
import snapchatLogo from '../../../assets/icons/snapchat.png';
import tikTokLogo from '../../../assets/icons/toktok.png';
import tikTokLogoWhite from '../../../assets/icons/toktok-white.png';
import tvIcon from '../../../assets/icons/watch-now.png';
import xLogo from '../../../assets/icons/x.png';
import xLogoWhite from '../../../assets/icons/x-white.png';
import youtubeLogo from '../../../assets/icons/youtube-icon.png';

const Footer = ({ theme }) => {
    const footerClass = classNames('Footer', {
            'Footer--dark': theme === 'dark',
        }),
        competitions = [
            {
                name: 'Eredivisie',
                link: 'https://www.espn.nl/eredivisie/',
                logo: theme === 'dark' ? eredivisieLogoDark : eredivisieLogo,
            },
            {
                name: 'Keuken Kampioen Divisie',
                link: 'https://www.espn.nl/keuken-kampioen-divisie/',
                logo: kkdLogo,
            },
            {
                name: 'TOTO KNVB Beker',
                link: 'https://www.espn.nl/knvb-beker/',
                logo: knvbLogo,
            },
            {
                name: 'Azerion Vrouwen Eredivisie',
                link: 'https://www.espn.nl/vrouwen-eredivisie/',
                logo: eredivisieVrouwenLogo,
            },
            {
                name: 'Europa League',
                link: 'https://www.espn.nl/voetbal/league/_/naam/uefa.europa/europa-league',
                logo: europaLeagueLogo,
            },
            {
                name: 'Conference League',
                link: 'https://www.espn.nl/vrouwen-eredivisie/',
                logo: conferenceLogo,
            },
        ],
        socials = [
            {
                name: 'X',
                link: 'https://twitter.com/ESPNNL',
                logo: theme === 'dark' ? xLogoWhite : xLogo,
            },
            {
                name: 'Facebook',
                link: 'https://www.facebook.com/ESPNNL/',
                logo: facebookLogo,
            },
            {
                name: 'Youtube',
                link: 'https://www.youtube.com/c/ESPNnl',
                logo: youtubeLogo,
            },
            {
                name: 'Instagram',
                link: 'https://www.instagram.com/ESPNNL/',
                logo: instagramLogo,
            },
            {
                name: 'TikTok',
                link: 'https://www.tiktok.com/@espnnl',
                logo: theme === 'dark' ? tikTokLogoWhite : tikTokLogo,
            },
            {
                name: 'Snapchat',
                link: 'https://www.snapchat.com/p/3ce3ae55-0341-48ab-978c-216835936fcc/1534115234983936',
                logo: snapchatLogo,
            },
        ],
        watchList = [
            {
                name: 'Live',
                link: 'https://www.espn.nl/watch/',
            },
            {
                name: 'Samenvattingen',
                link: 'https://www.espn.nl/watch/highlights',
            },
            {
                name: 'TV Gids',
                link: 'https://www.espn.nl/watch/speelkalender',
            },
        ],
        podcasts = [
            {
                name: 'iTunes',
                link: 'https://podcasts.apple.com/nl/podcast/voetbalpraat/id1399043180',
            },
            {
                name: 'Spotify',
                link: 'https://open.spotify.com/show/4lpkuJibQKPzuW9TTMMLQg',
            },
            {
                name: 'Stitcher',
                link: 'https://www.stitcher.com/show/fox-sports-nl',
            },
        ];

    return (
        <footer className={footerClass}>
            <a className="logo" href="https://espn.nl">
                <img width="73px" height="18px" src={logoRed} alt="ESPN logo" />
            </a>
            <div className="container">
                <section className="Footer__list competitions">
                    <h2 className="heading heading--extra-small">
                        Competities
                    </h2>
                    <ul className="list">
                        {competitions.map(comp => {
                            return (
                                <li className="list__item" key={comp.name}>
                                    <Link to={comp.link}>
                                        <img
                                            width="20px"
                                            height="20px"
                                            alt={`Logo van de ${comp.name}`}
                                            src={comp.logo}
                                        />
                                        {comp.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </section>
                <section className="Footer__list connect">
                    <h2 className="heading heading--extra-small">Connect</h2>
                    <ul className="list">
                        {socials.map(social => {
                            return (
                                <li className="list__item" key={social.link}>
                                    <Link
                                        to={social.link}
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            width="20px"
                                            height="20px"
                                            alt={`Logo van ${social.name}`}
                                            src={social.logo}
                                        />
                                        {social.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </section>
                <section className="Footer__list more">
                    <h2 className="heading heading--extra-small">Meer ESPN</h2>
                    <ul className="list">
                        <li className="list__item">
                            <Link to="https://www.espnzakelijk.nl/">
                                ESPN Zakelijk
                            </Link>
                        </li>
                        <li className="list__item">
                            <Link to="https://www.espnmanofthematch.nl/#games">
                                Man of the Match
                            </Link>
                        </li>
                        <li className="list__item">
                            <Link to="https://www.espn.nl/voetbal/artikel?id=7826476&_slug_=eredivisie-partners">
                                Eredivisie Partners
                            </Link>
                        </li>
                        <li className="list__item">
                            <Link to="/programmering">Programmering</Link>
                        </li>
                    </ul>
                </section>

                <section className="Footer__list watch">
                    <h2 className="heading heading--extra-small">Kijk nu</h2>
                    <ul className="list">
                        {watchList.map(watch => {
                            return (
                                <li className="list__item" key={watch.link}>
                                    <Link
                                        to={watch.link}
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            width="20px"
                                            height="20px"
                                            alt="Icoontje van een televisie"
                                            src={tvIcon}
                                        />
                                        {watch.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </section>
                <section className="Footer__list football-talk">
                    <h2 className="heading heading--extra-small">
                        ESPN Podcasts
                    </h2>
                    <ul className="list">
                        {podcasts.map(pod => {
                            return (
                                <li className="list__item" key={pod.link}>
                                    <Link
                                        rel="noopener noreferrer"
                                        to={pod.link}
                                    >
                                        <img
                                            width="20px"
                                            height="20px"
                                            alt="Icoontje van een microfoon"
                                            src={podcastIcon}
                                        />
                                        {pod.name}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </section>
            </div>
            <section className="Footer__bottom">
                <img
                    width="73px"
                    height="18px"
                    className="Footer__logo"
                    src={logo}
                    alt="Logo van ESPN"
                />
                <p>© ESPN Enterprises, Inc. Alle rechten voorbehouden.</p>
                <div className="Footer__links">
                    <a
                        href="https://disneytermsofuse.com/dutch-netherlands/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Gebruiksvoorwaarden
                    </a>
                    <a
                        href="https://privacy.thewaltdisneycompany.com/nl/privacybeleid/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Privacybeleid
                    </a>
                    <a
                        href="https://preferences-mgr.truste.com/?pid=disney01&aid=espnemea01&type=espn"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Gepersonaliseerde advertenties
                    </a>
                    <a
                        href="https://privacy.thewaltdisneycompany.com/nl/privacybeleid/privacybeleid-2/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Europese Privacy Regelgeving
                    </a>
                    <a
                        href="https://privacy.thewaltdisneycompany.com/nl/privacybeleid/cookiesbeleid/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Cookiebeleid
                    </a>
                    <a
                        href="https://espnnl.zendesk.com/hc/nl-nl"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Support
                    </a>
                    <a className="ot-sdk-show-settings" href="/#">
                        Manage Privacy Preferences
                    </a>
                </div>
            </section>
        </footer>
    );
};

export default Footer;
